module.exports = __webpack_public_path__ + "img/existing-resources-1-2.1f5f5ef0.jpg";